module.exports = __webpack_public_path__ + "static/media/1016865.9b0c7b22.jpg";